export class BriefHistoryCategoryModel {
    recalls: number 

    constructor(
        recalls: number, 
    ) {
        this.recalls = recalls 
    }
}